
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2.125l.906 2.063 3.25 7.281 7.938.844 2.25.25-1.688 1.5-5.906 5.344 1.656 7.813.469 2.188-1.969-1.125-6.906-4-6.906 4-1.969 1.125.469-2.188 1.656-7.813-5.906-5.344-1.688-1.5 2.25-.25 7.938-.844 3.25-7.281zm0 4.906l-2.563 5.781-.25.531-.563.063-6.281.656 4.688 4.219.438.406-.125.563-1.313 6.156 5.469-3.125.5-.313.5.313 5.469 3.125-1.313-6.156-.125-.563.438-.406 4.688-4.219-6.844-.719-.25-.531z"}})])
          )
        }
      }
    